const heading = document.querySelector(".heading")
const daysRef = document.querySelector("[data-value='days']");
const hoursRef = document.querySelector("[data-value='hours']");
const minutesRef = document.querySelector("[data-value='mins']");
const secondsRef = document.querySelector("[data-value='secs']");

const targetTime = new Date(2026, 5, 1);

const id = setInterval(() => {
  const currentTime = new Date();
  const time = targetTime - currentTime;

  if (time <= 0) {
    clearInterval(id);
    return;
    heading.textContent="Summer had arrived!"
  }

  const days = Math.floor(time / (1000 * 60 * 60 * 24));
  const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const mins = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
  const secs = Math.floor((time % (1000 * 60)) / 1000);

  daysRef.textContent = days;
  hoursRef.textContent = hours;
  minutesRef.textContent = mins;
  secondsRef.textContent = secs;
}, 1000);
